import React from "react";
import { createRoot } from "react-dom/client";
import LandingPage from "./components/landing-page/LandingPage";
import ClaimPage from "./components/claim-page/ClaimPage";

import "./styles/site.scss";
import "./styles/Utility.scss";
import "./styles/Typography.scss";
import "./styles/Heading.scss";
import "./styles/FallbackBanner.scss";
import "./styles/header.scss";

const claimContainer = document.getElementById("claimroot");
const rootContainer = document.getElementById("root");

if (claimContainer) {
    createRoot(claimContainer).render(<ClaimPage />);
} else if (rootContainer) {
    createRoot(rootContainer).render(<LandingPage />);
}
